import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Urls } from "../Urls";

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  constructor(private http: HttpClient) { }

  getMainApiInfo(): Observable<string> {
    return this.http.get(Urls.getMainApiInfo, {responseType: 'text'}).pipe(
      map((responseData) => {
        return responseData as string;
      })
    );
  }

}
